import type { Household } from 'api/btlApplicationForm/types';

export function mapHouseholdToOoExpensesFormValues(household?: Household): Record<string, unknown> {
  if (!household) {
    return {};
  }

  return {
    numberOfDependents13OrUnder: household.numberOfDependents13OrUnder,
    numberOfDependentsOver13: household.numberOfDependentsOver13,
    income: household.income,
    declaredExpenditure: household.declaredExpenditure,
    creditCommitments: household.creditCommitments,
  };
}
